/** Analytics: the sales dashboard's ranges, KPI tiles and top products. Conventions: see `common.ts`. */
const analytics: Record<string, string> = {
  title: 'Analytics',
  description:
    'Each figure is compared against the window immediately before it. Open any of them for the detail behind it.',
  all_reports: 'All reports →',
  loading: 'Crunching your numbers…',

  window: '{from} – {to}, against {compare_from} – {compare_to}',

  'range.locked_custom': 'Windows longer than a month are part of advanced analytics.',

  'filters.channel': 'Channel',
  'filters.all_channels': 'All channels',

  'chart.title': 'Revenue and orders',
  'chart.description': 'Day by day across the window, or week by week over a long one.',

  'kpi.vs_previous': 'vs {value} before',
  'kpi.repeat_hint': 'Have ordered more than once',
  'kpi.low_stock_hint': 'At or below their reorder point',

  'export.csv': 'Dashboard (CSV)',
  'export.done': 'Your dashboard export is downloading.',

  'range.today': 'Today',
  'range.7d': '7 days',
  'range.30d': '30 days',
  'range.90d': '90 days',
  'range.locked_hint': 'Available on plans with advanced analytics',
  'range.locked_notice': 'The 90-day view is part of advanced analytics, which your plan does not include.',
  'range.see_plans': 'See plans',

  'kpi.revenue': 'Revenue',
  'kpi.orders': 'Orders',
  'kpi.average_order': 'Average order',
  'kpi.cancelled': 'Cancelled',
  'kpi.new_customers': 'New customers',
  'kpi.repeat_customers': 'Repeat customers',
  'kpi.low_stock_skus': 'Low-stock SKUs',

  'top_products.title': 'Top products',
  'top_products.description': 'Ranked by revenue over the selected window.',
  'top_products.full_report': 'Full report',
  'top_products.units_sold': '{units} sold',
  'top_products.empty': 'No sales in this window yet.',

  // --- Revenue by channel (WhatsApp Commerce) ---
  'revenue_by_channel.title': 'Revenue by channel',
  'revenue_by_channel.description': 'Where the window\'s revenue came from.',
  'revenue_by_channel.empty': 'No revenue in this window yet.',
  'revenue_by_channel.orders': '{orders} orders',
  'revenue_by_channel.share': '{share}% of revenue',
};

export default analytics;
